import { render, staticRenderFns } from "./PaymentCard.vue?vue&type=template&id=be308cd8&scoped=true&"
import script from "./PaymentCard.vue?vue&type=script&lang=js&"
export * from "./PaymentCard.vue?vue&type=script&lang=js&"
import style0 from "./PaymentCard.vue?vue&type=style&index=0&id=be308cd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be308cd8",
  null
  
)

export default component.exports